import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { muteUser } from "../views/profile/reducers";
import { useConfirmModal, useTrans } from "../hooks";

export const useMuteUsers = onUserMuted => {
  const { trans } = useTrans();
  const dispatch = useDispatch();
  const { openConfirmModal } = useConfirmModal();
  const mutedUsers = useSelector(state => state.profileData.mutedUsers);

  const isInitialMount = useRef(true);

  const triggerUserMuted = () => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      if (onUserMuted && mutedUsers && mutedUsers.length > 0) {
        const username = mutedUsers[mutedUsers.length - 1].username;
        onUserMuted(username);
      }
    }
  };

  useEffect(triggerUserMuted, [mutedUsers]);

  const onMute = username => {
    dispatch(muteUser(username));
  };

  const openMuteUserModal = (username, muteButtonRef) => {
    openConfirmModal({
      contentText: trans(
        "This account will not be able to follow you, send you messages, post on your profile or comment on your stories. This action can take 30 minutes to take effect."
      ),
      title: trans("Mute %s", username),
      confirmLabel: trans("Mute"),
      declineLabel: trans("Cancel"),
      onConfirmClick: () => onMute(username),
      openTriggerRef: muteButtonRef
    });
  };

  return { openMuteUserModal };
};
